import React from "react";
import { ExternalLink, Sparkles } from "lucide-react";

function ageLabel(hours) {
  if (hours == null) return "";
  if (hours < 1) return `${Math.max(1, Math.round(hours * 60))}m ago`;
  if (hours < 24) return `${Math.round(hours)}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

export default function StoryCard({ story, index, onSelect }) {
  return (
    <article
      data-testid={`story-card-${index}`}
      className="story-card border-b border-gray-200 p-4 sm:p-6 cursor-pointer group fade-up"
      style={{ animationDelay: `${Math.min(index * 30, 300)}ms` }}
      onClick={() => onSelect(story)}
    >
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex items-center gap-2 sm:gap-3 text-[10px] sm:text-xs font-mono uppercase tracking-[0.14em] sm:tracking-[0.18em] text-gray-500 flex-wrap min-w-0 flex-1">
          <span className="text-[#7C3AED] font-semibold">{story.category}</span>
          <span className="text-gray-300 hidden sm:inline">/</span>
          <span className="truncate max-w-[110px] sm:max-w-[200px]">{story.source}</span>
          <span className="text-gray-300">·</span>
          <span>{ageLabel(story.age_hours)}</span>
          {story.custom && (
            <span
              data-testid={`story-custom-${index}`}
              title="From one of your custom RSS feeds"
              className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] tracking-widest border border-[#7C3AED]/30 text-[#7C3AED] bg-[#EFE6FE]"
            >
              Your source
            </span>
          )}
          {story.fallback && (
            <span
              data-testid={`story-fallback-${index}`}
              title="No fresh stories in the last 72 hours for this niche — showing the past week instead."
              className="inline-flex items-center px-1.5 py-0.5 rounded text-[9px] tracking-widest border border-amber-300 text-amber-700 bg-amber-50"
            >
              7d window
            </span>
          )}
        </div>
        <a
          href={story.url}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="text-gray-400 hover:text-[#0a0a0a] shrink-0 -m-1 p-1"
          data-testid={`story-external-${index}`}
          aria-label="Open source"
        >
          <ExternalLink size={14} strokeWidth={1.5} />
        </a>
      </div>

      <h2 className="font-serif text-xl sm:text-2xl lg:text-3xl leading-tight tracking-tight text-[#0a0a0a] mb-2 group-hover:underline decoration-1 underline-offset-4">
        {story.title}
      </h2>

      {story.summary && (
        <p className="text-sm text-gray-600 leading-relaxed line-clamp-2 max-w-3xl">
          {story.summary}
        </p>
      )}

      <div className="mt-3 sm:mt-4 inline-flex items-center gap-2 text-[10px] sm:text-xs font-mono uppercase tracking-widest text-[#7C3AED] sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
        <Sparkles size={12} strokeWidth={1.5} />
        Generate talking points
      </div>
    </article>
  );
}
